<template>
  <v-dialog v-model="internalDialog" content-class="dialog-fit-content">
    <v-card data-test="sender-history-dialog">
      <v-card-title class="headline">
        Histórico: {{ formattedSenderPhone }}
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          hide-actions
        >
          <v-progress-linear
            slot="progress"
            color="blue"
            indeterminate
          ></v-progress-linear>

          <template slot="items" slot-scope="props">
            <tr data-test="history-row">
              <td class="text-xs-left">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ props.item.updated_at | formatDateTime }}
                    </span>
                  </template>
                  <span>{{ props.item.updated_at | formatDateAgo }}</span>
                </v-tooltip>
              </td>

            <td class="text-xs-left caption grey--text text--lighten-1">
              <FlaggedIcon
                v-if="
                  props.item.meta_status && props.item.meta_status === 'FLAGGED'
                "
              ></FlaggedIcon>
            </td>

            <td class="text-xs-left">
              <div v-if="props.item.status">
                <SenderStatusChip
                  :status="props.item.status"
                  :tooltip="props.item.status_cause"
                  :options="statusOptions"
                  disabled
                />
              </div>
              <span v-else>--</span>
            </td>

              <td class="text-xs-left">
                <QualityChip :quality="props.item.meta_quality_rating_v2" />
              </td>

              <td class="text-xs-left">
                <ThroughputChip :level="props.item.details.throughput.level" />
              </td>

              <td class="text-no-wrap">
                {{ props.item.initiative_details || "--" }}
              </td>

              <td
                class="text-xs-right d-flex flex-row justify-end align-center"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      data-test="view-details-btn"
                      v-if="props.item.details"
                      v-bind="attrs"
                      color="grey"
                      v-on="on"
                      small
                      flat
                      icon
                      @click="
                        () => {
                          detailToShow = props.item.details;
                          detailDialog = true;
                        }
                      "
                    >
                      <v-icon>remember_me</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver detalhes</span>
                </v-tooltip>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <div v-if="loading" class="text-xs-center pa-3">Carregando...</div>
            <div v-else class="text-xs-center pa-5 grey--text">
              <v-icon large color="grey lighten-1" class="mb-2"
                >info_outline</v-icon
              >
              <div class="subheading">Nenhum histórico disponível.</div>
            </div>
          </template>
        </v-data-table>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          flat
          @click="internalDialog = false"
          data-test="close-sender-history-dialog-btn"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>

    <MetaDetailDialog
      v-model="detailDialog"
      title="Detalhes"
      :data="detailToShow"
    />
  </v-dialog>
</template>

<script>
import QualityChip from "@/components/ui/QualityChip.vue";
import FlaggedIcon from "@/components/ui/FlaggedIcon.vue";
import MetaDetailDialog from "./MetaDetailDialog.vue";
import ThroughputChip from "./ThroughputChip.vue";
import SenderStatusChip from "./SenderStatusChip.vue";

export default {
  components: {
    QualityChip,
    MetaDetailDialog,
    ThroughputChip,
    FlaggedIcon,
    SenderStatusChip,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    sender: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      detailDialog: false,
      detailToShow: {},
      headers: [
        { text: "Atualizado em", value: "updated_at", sortable: false },
        { text: "", value: "meta_status", sortable: false },
        {
          text: "Status",
          value: "status",
          sortable: false,
        },
        {
          text: "Qualidade",
          value: "meta_quality_rating_v2",
          sortable: false,
        },
        {
          text: "Nível de Vazão Meta",
          value: "details.throughput.level",
          sortable: false,
        },
        {
          text: "Iniciativa",
          value: "initiative_details",
          sortable: false,
        },
        { text: "", value: "details", sortable: false },
      ],
    };
  },

  computed: {
    formattedSenderPhone() {
      if (this.sender && this.sender.phone_number) {
        return this.$options.filters.phoneNumber(this.sender.phone_number);
      }
      return "";
    },
    internalDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dialog-fit-content {
  width: auto !important;
  max-width: 95vw !important;
  display: inline-table;
}
</style>
